import { createSlice } from "@reduxjs/toolkit";
import { isBlankOrNull } from "utils";

const initialState = {
  isAuthenticated: false,
  userInfo: null,
  role: null,
  token: null,
  currentWebComponent: null,
  sessionExpiry: null,
  graphData: null,
  permissions: [],
  // Temporary
  activateAccount: null,
};
// Load session state from sessionStorage
const savedSession = sessionStorage.getItem("appSession");
const persistedState = savedSession ? JSON.parse(savedSession) : initialState;

const slice = createSlice({
  name: "auth",
  initialState: persistedState,
  reducers: {
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setCredentials: (state, { payload: { userInfo, role, token, sessionExpiry } }) => {
      state.userInfo = userInfo;
      state.role = role;
      state.token = token;
      state.sessionExpiry = sessionExpiry;
    },
    setCurrentWebComponent: (state, action) => {
      state.currentWebComponent = action.payload;
    },
    setGraphInfo: (state, action) => {
      state.graphData = action.payload;
    },
    // Temporary
    setActivateAccount: (state, action) => {
      state.activateAccount = action.payload;
    },
    clearSession: async (state, action) => {
      const msalInstance = action.payload;
      console.log("clearSession msalInstance: ", msalInstance.getActiveAccount());
      const account = msalInstance.getActiveAccount();
      if (!isBlankOrNull(account)) {
        msalInstance.logoutRedirect({
          account: msalInstance.getActiveAccount(),
          postLogoutRedirectUri: `${process.env.REACT_APP_REDIRECT_URI}`,
        });
      }
      sessionStorage.removeItem("appSession");
      return initialState;
    },
    clearInfo: state => {
      return {
        ...state,
        role: null,
      };
    },
  },
});
export const {
  setCredentials,
  setAuthenticated,
  setUser,
  setRole,
  setPermissions,
  setCurrentWebComponent,
  setGraphInfo,
  setActivateAccount,
  clearSession,
  clearInfo,
} = slice.actions;

export default slice.reducer;

export const authReducer = state => state.auth.user;

// Middleware to save state to sessionStorage
export const sessionMiddleware = storeAPI => next => action => {
  const result = next(action);
  const state = storeAPI.getState();
  sessionStorage.setItem("appSession", JSON.stringify(state.auth));
  return result;
};
